export const lightTheme = {
  homeTitle: '#212529',
  tableHeader: '#FBFBFB',
  oddRow: '#FFFFFF',
  oddRowHover: '#FBFBFB',
  rowColor: 'rgba(0, 0, 0, 0.87)',
  filterBar: 'rgba(224, 224, 224, 0.5)',
  filterBarColor: 'rgba(0, 0, 0, 0.87)',
  homeLoaderBackground: '#FFFFFF',
  noGamesDescription: '#A0A0A0',
  metricsTab: '#DFDFE1',
  activeMetric: '#FFFFFF',
  metricsTabDivider: '#FFFFFF',
  metricsTabColor: '#212529',
  activeMetricColor: '#212529',
  changeDataColor: '#212529',
  changeDataIconColor: '#212529',
  toolbarTeam: '#222222',
  tablePaginationBackground: '#FFFFFF',
  tablePaginationColor: '#222222',
  lightIconFill: '#414141',
  darkIconFill: '#414141',
  darkModeBackground: '#A0A0A0',
  darkModeBorder: '#A0A0A0',
  tablePaginationBtnBackground: 'rgb(65, 65, 65)',
  tablePaginationBtnColor: '#FFFFFF',
  mainMenuBackgroundColor: '#FFFFFF',
  mainMenuColor: '#414141',
  mainMenuIconsColor: '#414141',
  profileBackground: '#FFFFFF',
  profileBorderColor: '#FFFFFF',
  initialsColor: '#414141',
  tableBackground: '#FFFFFF',
  filterBackground: '#FFFFFF',
  filterInputBackground: '#FFFFFF',
  filterPlaceholderColor: 'rgba(0,0,0,0.54)',
  filterBorderColor: '#A0A0A0',
  filterInputColor: 'rgba(0,0,0,0.54)',
  activeFilterBorderColor: '#EC691A',
  loaderColor: '#ec691a',
  pinnedFiltersBackground: 'rgba(88, 144, 222, 0.4)',
  scrollOverflowShadowColor: '#F0F0F0',
  filterScrollBackground: '#FFFFFF',
  filterScrollHeight: '2px',
  disabledFilterColor: 'rgba(65,65,65,0.45)',
  checkboxBorder: 'none',
  checkboxFill: '#A0A0A0',
  tableBorderColor: '#E0E0E0',
  errorHeadlineColor: '#414141',
  toolbarWarmupBackground: '#FE9800',
  toolbarTitle: '#7b7b7b',
  toolbarTeamName: '#222222',
  toolbarBackground: '#FFFFFF',
  toolbarLabel: '#7b7b7b',
  toolbarValue: '#222222',
  pageBackground: '#f8f9fa',
  titleBarBackgroundColor: '#FFFFFF',
  titleBarColor: '#414141',
  backButtonBackgroundColor: '#F5F5F5',
  backButtonIconFill: '#414141',
  teamValueColor: '#414141',
  selectedTabColor: '#414141',
  secondRowBorderColor: 'transparent',
  inningFill: '#7b7b7b',
  dataValueColor: '#414141',
  iconButtonBackgroundColor: '#F5F5F5',
  iconButtonFill: '#414141',
  inputBackgroundColor: '#FFFFFF',
  inputPlaceholderColor: '#414141',
  inputTextColor: '#414141',
  switchTextColor: '#414141',
  switchCircleBackgroundColor: '#ffffff',
  switchTrackBackground: '#e0e0e0',
  switchTrackCheckedBackground: '#ec691a',
  watchArrowFill: '#414141',
  tableFooterBackgroundColor: '#ffffff',
  tableFooterColor: '#414141',
  noDataBackgroundColor: '#ffffff',
  skeletonBackgroundColor: 'rgba(0, 0, 0, 0.11)',
  skeletonPillBackground: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent)',
  // App Switcher
  appSwitcherBackgroundColor: '#FFFFFF',
  appSwitcherColor: '##414141',
  appSwitcherButtonColor: '#0009',
  appSwitcherButtonSelectedColor: '#414141',
  appSwitcherIconFill: '#414141',
  appSwitcherItemHover: '#f5f5f5',
  appSwitcherItemSelectedBackgroundColor: 'rgb(245, 245, 245)',
};

export const darkTheme = {
  homeTitle: '#FFFFFF',
  tableHeader: '#7B7B7B',
  oddRow: '#414141',
  oddRowHover: '#585858',
  evenRow: '#3B3B3B',
  rowColor: '#FFFFFF',
  filterBar: '#2A2A2A',
  filterBarColor: '#FFFFFF',
  homeLoaderBackground: '#2A2A2A',
  noGamesDescription: '#E0E0E0',
  metricsTab: '#2C2C2C',
  activeMetric: '#545454',
  metricsTabDivider: '#414141',
  metricsTabColor: '#F5F5F5',
  activeMetricColor: '#FFFFFF',
  changeDataColor: '#FFFFFF',
  changeDataIconColor: '#A0A0A0',
  toolbarTeam: '#FFFFFF',
  tablePaginationBackground: '#414141',
  tablePaginationColor: '#FFFFFF',
  lightIconFill: '#FFFFFF',
  darkIconFill: '#FFFFFF',
  darkModeBackground: '#7b7b7b',
  darkModeBorder: '#6f6f6f',
  tablePaginationBtnBackground: '#A0A0A0',
  tablePaginationBtnColor: '#FFFFFF',
  mainMenuBackgroundColor: '#414141',
  mainMenuColor: '#FFFFFF',
  mainMenuIconsColor: '#FFFFFF',
  profileBackground: '#414141',
  profileBorderColor: '#414141',
  initialsColor: '#FFFFFF',
  tableBackground: '#313131',
  filterBackground: '#222222',
  filterInputBackground: '#414141',
  filterPlaceholderColor: '#A0A0A0',
  filterBorderColor: '#a0a0a066',
  filterInputColor: '#FFFFFF',
  activeFilterBorderColor: '#EC691A',
  loaderColor: '#FFFFFF',
  pinnedFiltersBackground: 'rgba(88, 144, 222, 0.4)',
  scrollOverflowShadowColor: '#222222',
  filterScrollBackground: '#3B3B3B',
  filterScrollHeight: '5px',
  disabledFilterColor: 'rgba(255, 255 ,255 ,0.45)',
  checkboxBorder: '1px solid #7b7b7b',
  checkboxFill: '#555555',
  tableBorderColor: '#7B7B7B',
  errorHeadlineColor: '#FFFFFF',
  toolbarWarmupBackground: '#FE9800',
  toolbarTitle: '#e0e0e0',
  toolbarTeamName: '#ffffff',
  toolbarBackground: '#414141',
  toolbarLabel: '#E0E0E0',
  toolbarValue: '#FFFFFF',
  pageBackground: '#222222',
  titleBarBackgroundColor: '#414141',
  titleBarColor: '#FBFBFB',
  backButtonBackgroundColor: '#7B7B7B',
  backButtonIconFill: '#FFFFFF',
  teamValueColor: '#FBFBFB',
  selectedTabColor: '#FBFBFB',
  secondRowBorderColor: '#7B7B7B',
  inningFill: '#A0A0A0',
  dataValueColor: '#FBFBFB',
  iconButtonBackgroundColor: '#7B7B7B',
  iconButtonFill: '#ffffff',
  inputBackgroundColor: '#414141',
  inputPlaceholderColor: '#A0A0A0',
  inputTextColor: '#FFFFFF',
  switchTextColor: '#FBFBFB',
  switchCircleBackgroundColor: '#7b7b7b',
  switchTrackBackground: '#414141',
  switchTrackCheckedBackground: '#ec691a',
  watchArrowFill: '#FBFBFB',
  tableFooterBackgroundColor: '#414141',
  tableFooterColor: '#FBFBFB',
  noDataBackgroundColor: '#414141',
  skeletonBackgroundColor: '#7b7b7b',
  skeletonPillBackground: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.14), transparent)',
  // App Switcher
  appSwitcherBackgroundColor: '#222222',
  appSwitcherColor: '#FBFBFB',
  appSwitcherButtonColor: '#A0A0A0',
  appSwitcherButtonSelectedColor: '#EC691A',
  appSwitcherIconFill: '#FBFBFB',
  appSwitcherItemHover: 'rgba(65, 65, 65, 0.60)',
  appSwitcherItemSelectedBackgroundColor: 'rgba(65, 65, 65, 0.60)',
};
